// Configuration de l'URL de l'API depuis les variables d'environnement
// Modifier dans le fichier .env : REACT_APP_API_URL=http://VOTRE_IP:5000

export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const WS_URL = process.env.REACT_APP_WS_URL;
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;

export default API_BASE_URL;
